import Link from "next/link";
import axios from "axios";

import BaseLayout from "../components/layouts/BaseLayout";
import ReservationsList from "../components/reservations/ReservationsList";

const Index = ({ reservations }) => (
  <BaseLayout>
    <div className="section">
      <h4 className="title is-4">Selecione uma das opções:</h4>

      <div className="columns">
        <div className="column">
          <div className="box">
            <a href="http://reservas-videoconf.uffs.edu.br">
              <article className="media">
                <figure className="media-left">
                  <p className="image is-64x64 has-text-centered">
                    <i className="far fa-calendar-check fa-4x" aria-hidden="true" />
                  </p>
                </figure>
                <div className="media-content">
                  <div className="content">
                    <h4 className="title is-4">Sistema de reservas</h4>
                    <p className="subtitle is-6">
                      Consulte a agenda de videoconferências, reserve ou cancele uma reunião.
                    </p>
                  </div>
                </div>
              </article>
            </a>
          </div>
        </div>
        {/* .column */}

        <div className="column">
          <div className="box">
            <a href="http://videoconf.uffs.edu.br">
              <article className="media">
                <figure className="media-left">
                  <p className="image is-64x64">
                    <img src="/static/logo-scopia.png" />
                  </p>
                </figure>
                <div className="media-content">
                  <div className="content">
                    <h4 className="title is-4">Scopia Desktop</h4>
                    <p className="subtitle is-6">Participe de videoconferências direto do seu computador.</p>
                  </div>
                </div>
              </article>
            </a>
          </div>
        </div>
        {/* .column */}
      </div>
      {/* .columns */}

      <div className="columns">
        <div className="column">
          <div className="box">
            <a href="https://conferenciaweb.rnp.br/">
              <article className="media">
                <figure className="media-left">
                  <p className="image is-64x64">
                    <img src="/static/logo-mconf.png" />
                  </p>
                </figure>
                <div className="media-content">
                  <div className="content">
                    <h4 className="title is-4">Conferênciaweb RNP</h4>
                    <p className="subtitle is-6">
                      Serviço de videoconferência da RNP que funciona diretamente do seu <em>browser</em>.
                    </p>
                  </div>
                </div>
              </article>
            </a>
          </div>
        </div>
        {/* .column */}

        <div className="column">
          <div className="box">
            <a href="https://ati.uffs.edu.br/public.pl?Action=PublicFAQExplorer;CategoryID=20;SortBy=Title;Order=Up">
              <article className="media">
                <figure className="media-left">
                  <p className="image is-64x64 has-text-centered">
                    <i className="fas fa-question-circle fa-4x" />
                  </p>
                </figure>
                <div className="media-content">
                  <div className="content">
                    <h4 className="title is-4">Perguntas frequentes</h4>
                    <p className="subtitle is-6">
                      Manuais e soluções para problemas frequentes enfrentados pelos usuários do serviço de
                      videoconferências.
                    </p>
                  </div>
                </div>
              </article>
            </a>
          </div>
        </div>
        {/* .column */}
      </div>
      {/* .columns */}

      <div className="columns">
        <div className="column">
          <div className="box">
            <Link href="/recomendacoes">
              <a>
                <article className="media">
                  <figure className="media-left">
                    <p className="image is-64x64 has-text-centered">
                      <i className="fas fa-info-circle fa-4x" />
                    </p>
                  </figure>
                  <div className="media-content">
                    <div className="content">
                      <h4 className="title is-4">Boas práticas</h4>
                      <p className="subtitle is-6">
                        Algumas dicas para aproveitar ao máximo os recursos do Serviço de Videoconferências.
                      </p>
                    </div>
                  </div>
                </article>
              </a>
            </Link>
          </div>
        </div>
        {/* .column */}

        <div className="column">
          <div className="box">
            <Link href="/estatisticas">
              <a className="link">
                <article className="media">
                  <figure className="media-left">
                    <p className="image is-64x64 has-text-centered">
                      <i className="fas fa-chart-bar fa-4x" />
                    </p>
                  </figure>
                  <div className="media-content">
                    <div className="content">
                      <h4 className="title is-4">Estatísticas de uso</h4>
                      <p className="subtitle is-6">
                        Visualização de dadso de utilização do Serviço de Videoconferências.
                      </p>
                    </div>
                  </div>
                </article>
              </a>
            </Link>
          </div>
        </div>
        {/* .column */}
      </div>
      {/* .columns */}

      <ReservationsList reservations={reservations} />

      <br />
      <h4 className="title is-4">Sobre o Serviço de Videoconferências:</h4>
      <p>
        O Serviço de Videoconferências da UFFS conta com 16 salas à disposição para realização de reuniões de caráter
        administratvio ou acadêmico com participantes localizados em todas as suas unidades (ou outras instituições). O
        agendamento e participação das reuniões por videoconferência segue o estabelecido na{" "}
        <a href="https://www.uffs.edu.br/atos-normativos/resolucao/consunicapgp/2017-0002" target="_blank">
          Resolução nº 2/2017 - CONSUNI/CAPGP
        </a>.
        <br />
      </p>
    </div>

    <style jsx>{`
      .box a {
        color: #000;
        display: block;
      }

      .media-content {
        overflow: hidden;
      }

      .content ul {
        margin-top: 0;
      }

      .image {
        color: #444;
      }

      a:hover .image {
        color: #00693e;
      }

      a:hover .content * {
        color: #00693e;
      }
    `}</style>
  </BaseLayout>
);

Index.getInitialProps = async function() {
  let reservations = [];

  try {
    const { data } = await axios.get(`${process.env.BACKEND_URL}/reservations`);
    reservations = data.reservations || [];
  } catch (e) {
    reservations = [];
  }

  return {
    reservations: reservations.slice(0, 10)
  };
};

export default Index;



// WEBPACK FOOTER //
// pages/index.js